<template>
  <div
    id="app"
    class="outsider"
  >
    <gl-card class="index-card">
      <div slot="header">
        广联运营平台
      </div>
      <ul>
        <li>
          <a href="../customer/account/index.html">账户管理</a>
        </li>
        <li>
          <a href="../customer/account/add.html">添加账户</a>
        </li>
        <li>
          <a href="../customer/dictionaryManage/index.html">字典类型</a>
        </li>
        <li>
          <a href="../customer/dictionaryManage/dictionaryData.html">字典数据</a>
        </li>
        <li>
          <a
            href="../productManage/productList.html"
            target="_self"
          >
            产品列表
          </a>
        </li>
        <li>
          <a
            href="../productManage/menuList.html"
            target="_self"
          >
            菜单列表
          </a>
        </li>
        <li>
          <a
            href="../productManage/functionList.html"
            target="_self"
          >
            功能管理
          </a>
        </li>
      </ul>
    </gl-card>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style scoped>
.outsider {
  background-color: #fff;
  padding: 20px 0px 40px 0px;
  /* margin: 20px 20px; */
}
</style>
